const isString = value => (typeof value === 'string' || value instanceof String);

export default isString;
